export default __webpack_public_path__ + "static/media/Spectral-ExtraBoldItalic.8d30dee9.ttf";